import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  mutation EditFinancialsTemplate($objectId: FinancialsTemplateID!, $input: FinancialsTemplateInput!) {
    editFinancialsTemplate(objectId: $objectId, input: $input) {
      ...FinancialsTemplateFields
      indicators {
        ...IndicatorFields
      }
    }
  }

  ${IndicatorFieldsFragment}
  ${FinancialsTemplateFieldsFragment}
`;
